<template>
    <aside class="contact-details">
        <h2 class="contact-details__service-name" v-html="serviceName"></h2>
        <p class="contact-details__paragraph">
            <slot name="paragraph"></slot>
        </p>

        <div class="contact-details__card">
            <div :style="{'background-image': `url(${image})`}" class="contact-details__image" v-html="imageAlt"></div>
            <p class="contact-details__content">
                <slot name="contact-details"></slot>
            </p>
        </div>
    </aside>
</template>

<script>
    export default {
        name: 'ContactDetails',

        props: {
            serviceName: { type: String, required: true },
            image:       { type: String, required: true },
            imageAlt:    { type: String, required: true },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';

    .contact-details {
        margin-bottom: 6rem;

        &__service-name {
            @extend %font-OpenSans-bold;

            margin-bottom: 1.2rem;

            color:         $gray-500;
            font-size:     1.6rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                margin-bottom: 0.2rem;
                font-size:     2.4rem;
            }
        }

        &__paragraph {
            margin-bottom: 2rem;

            color:         $gray-500;
            font-size:     1.2rem;
            line-height:   (22/12);

            @media screen and (min-width: map_get($grid-breakpoints, 'lg')) {
                font-size:   1.6rem;
                line-height: (30/16);
            }
        }

        &__card {
            display:        flex;
            flex-direction: column;

            background:     $white;
            border:         0.1rem solid $gray-300;
        }

        &__image {
            flex:            0 0 50%;

            background-size: cover;

            &::before {
                content:     '';
                display:     block;

                padding-top: (237px * 100% / 275px);
            }
        }

        &__content {
            margin:  0;
            padding: 1.5rem;

            * {
                margin: 0;
            }

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                padding: 4rem 5rem;
            }
        }
    }
</style>
